import { createContext } from 'react';

import { DEFAULT_API_URL } from './constants';

export type GlobalContextValue = {
  apiDescriptionUrl: string;
  setDescriptionUrl: (value: string) => void;
  layout?: 'stacked' | 'sidebar';
};

export const defaultGlobalContext: GlobalContextValue = {
  apiDescriptionUrl: DEFAULT_API_URL,
  setDescriptionUrl: () => {},
};

export const GlobalContext = createContext<GlobalContextValue>(defaultGlobalContext);
